import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { verifyEmail } from '../../configs/auth';

const ValidateEmail = () => {
    const { token } = useParams();
    const [status, setStatus] = useState('pending');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const validate = async () => {
            try {
                const response = await verifyEmail(token);
                if (response.status === 200) {
                    setStatus('success');
                    setMessage('Az email címed sikeresen megerősítve!');
                } else if (response.status === 400) {
                    setStatus('error');
                    setMessage('Érvénytelen vagy lejárt token.');
                } else {
                    setStatus('error');
                    setMessage('Hiba történt az email ellenőrzése során.');
                }
            } catch (err) {
                setStatus('error');
                setMessage('Hiba történt az email ellenőrzése során.');
            }
        };

        validate();
    }, [token]);

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center p-0">
            <div className="col-lg-5 col-md-9 col-11 my-5 p-4 d-flex flex-column justify-content-center align-items-center border shadow">
                <h4 className="mb-4">Email cím megerősítése</h4>

                {status === 'pending' && <p>Az email címed ellenőrzése folyamatban...</p>}
                {status === 'success' && <p className="text-success">{message}</p>}
                {status === 'error' && <p className="text-danger">{message}</p>}

                {status === 'success' && (
                    <div className="col-12 d-flex justify-content-center mt-3">
                        <Link to="/login" className="btn btn-home-primary">Bejelentkezés</Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ValidateEmail;
